import styled from "styled-components";

// ?Will Work on the 320 px media screen query later

export const StyleContainer = styled.div`
  display: grid;
  grid-template-columns: auto auto;
  grid-template-rows: auto auto;
  grid-gap: 13px;
  @media screen and (max-width: 600px) {
    grid-template-columns: 1fr;
    grid-template-rows: repeat(3, auto);
  }
  div.hero-text__section {
    grid-column: 1/3;
    div.text-content {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      margin-top: 5rem;
      div.name {
        svg {
          height: 5rem;
          width: auto;
          @media screen and (max-width: 967px) {
            height: 4rem;
          }
          @media screen and (max-width: 760px) {
            height: 3rem;
          }
          @media screen and (max-width: 420px) {
            height: 2rem;
          }
        }
        div.Name {
          display: inline-block;
          @media screen and (max-width: 420px) {
            font-size: 0.8rem;
          }
          span {
            font-size: 9rem;
            color: #4da5e3;
            @media screen and (max-width: 1115px) {
              font-size: 7rem;
            }
            @media screen and (max-width: 967px) {
              font-size: 5rem;
            }
            @media screen and (max-width: 760px) {
              font-size: 3rem;
            }
            @media screen and (max-width: 420px) {
              font-size: 2.5rem;
            }
          }
        }
      }
      div.skillset {
        width: 60%;
        @media screen and (max-width: 760px) {
          width: 70%;
        }
        margin-top: 0.5rem;
        span:nth-of-type(1) {
          font-size: 1.5rem;
          color: #336d96;
          font-weight: bold;
          @media screen and (max-width: 1115px) {
            font-size: 1.3rem;
          }
          @media screen and (max-width: 760px) {
            font-size: 1.1rem;
          }
          @media screen and (max-width: 420px) {
            font-size: 0.9rem;
          }
        }
        span:nth-of-type(2) {
          font-size: 1.2rem;
          color: #608096;
          @media screen and (max-width: 1115px) {
            font-size: 1.1rem;
          }
          @media screen and (max-width: 420px) {
            font-size: 0.8rem;
          }
        }
      }

      button.downloadCV {
        width: 14rem;
        font-size: 1.5rem;
        height: 3rem;
        letter-spacing: 0.05rem;
        margin-top: 0.5rem;
        color: #fafafa;
        cursor: pointer;
        border-radius: 0.5rem;
        background: #193549;
        border: 1px solid #1c5661;
        transition: all 0.3s ease-in;
        display: flex;
        justify-content: space-around;
        align-items: center;
        @media screen and (max-width: 760px) {
          width: 12rem;
          font-size: 1.3rem;
          height: 2.8rem;
        }
        @media screen and (max-width: 420px) {
          width: 9rem;
          font-size: 1rem;
          height: 2.5rem;
        }
        :hover {
          transform: scale(1.1);
        }
        a {
          text-decoration: none;
          color: #fafafa;
          display: flex;
          justify-content: space-around;
          align-items: center;
        }
      }
    }
  }
  div.hero-img__container {
    margin: 1rem 3rem;
    @media screen and (max-width: 600px) {
      grid-column: 1 / 3;
    }
    table {
      pointer-events: none;
      height: 30rem;
      width: 30rem;
      border-radius: 50%;
      background-color: #405563;
      z-index: 1;
      @media screen and (max-width: 1115px) {
        width: 25rem;
        height: 25rem;
      }
      @media screen and (max-width: 1115px) {
        width: 17rem;
        height: 17rem;
      }
      @media screen and (max-width: 760px) {
        width: 11rem;
        height: 11rem;
      }
      @media screen and (max-width: 600px) {
        width: 15rem;
        height: 15rem;
      }
      @media screen and (max-width: 420px) {
        width: 11rem;
        height: 11rem;
      }
      img {
        pointer-events: none;
        height: 6rem;
        width: auto;
        z-index: -1;
        @media screen and (max-width: 1115px) {
          height: 5rem;
          object-fit: cover;
          object-position: center;
        }
        @media screen and (max-width: 967px) {
          height: 3.5rem;
          object-fit: cover;
          object-position: center;
        }
        @media screen and (max-width: 760px) {
          height: 2.9rem;
        }
        @media screen and (max-width: 600px) {
          height: 3.5rem;
        }
        @media screen and (max-width: 420px) {
          height: 3rem;
        }
      }
    }
  }
  div.hero-aside__section {
    display: grid;
    place-items: center;
    height: 32rem;
    margin: 1rem 3rem 0 0;

    @media screen and (max-width: 1115px) {
      height: 27rem;
    }
    @media screen and (max-width: 967px) {
      height: 18rem;
      margin: 1rem 1.5rem 1rem 0;
    }
    @media screen and (max-width: 760px) {
      height: 16rem;
      margin: 1rem 1.2rem 1rem 0;
    }
    @media screen and (max-width: 600px) {
      margin: 0 auto;
      text-align: center;
    }
    div.hero-aside__text {
      font-size: 3rem;
      margin: 5px auto 10px;
      line-height: 1.6;

      @media screen and (max-width: 1115px) {
        font-size: 2rem;
      }
      @media screen and (max-width: 967px) {
        font-size: 1.5rem;
        line-height: 1.7;
      }
      @media screen and (max-width: 760px) {
        font-size: 1rem;
        line-height: 1.7;
      }
      @media screen and (max-width: 600px) {
        font-size: 1.3rem;
        line-height: 1.7;
      }
      div {
        font-size: 4rem;
        color: #966215;
        font-weight: Bold;
        @media screen and (max-width: 1115px) {
          font-size: 3rem;
        }
        @media screen and (max-width: 967px) {
          font-size: 2rem;
          line-height: 2;
        }
        @media screen and (max-width: 760px) {
          font-size: 1.5rem;
          line-height: 2.3;
        }
        @media screen and (max-width: 600px) {
          font-size: 1.8rem;
          line-height: 2.3;
        }
        a {
          text-decoration: none;
          color: #a86d3d;
          border: 5px solid #966215;
          padding: 0.3rem;
        }
      }
    }
    div.social-links {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      margin: 0.5rem 35px 0.5rem 0;
      @media screen and (max-width: 1115px) {
        margin: 0.2rem 20px 0rem 0;
      }
      @media screen and (max-width: 967px) {
        margin: 0.2rem 12px 0rem 0;
      }
      @media screen and (max-width: 600px) {
        margin: 0.2rem 25px 0rem 15px;
      }
      a {
        display: grid;
        place-items: center;
        text-decoration: none;
        height: 7rem;
        width: 7rem;
        border: 5px solid #427396;
        border-radius: 12px;
        @media screen and (max-width: 1115px) {
          height: 5rem;
          width: 6rem;
        }
        @media screen and (max-width: 967px) {
          height: 4.5rem;
          width: 5rem;
        }
        @media screen and (max-width: 760px) {
          height: 3rem;
          width: auto;
          border: none;
        }
        @media screen and (max-width: 600px) {
          height: 3.5rem;
          width: auto;
          border: none;
        }
        svg {
          font-size: 4rem;
          padding: 0.3rem;
          color: #19574f;
          @media screen and (max-width: 1115px) {
            font-size: 3rem;
          }
          @media screen and (max-width: 967px) {
            font-size: 2.5rem;
          }
        }
        div {
          color: #966215;
          padding: 0.5rem auto;
          font-weight: bold;
          @media screen and (max-width: 967px) {
            font-size: smaller;
            padding: 0.2rem auto;
          }
        }
      }
    }
    div.buyCoffee {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 1rem;
      div {
        svg {
          font-size: 5rem;
          @media screen and (max-width: 1115px) {
            font-size: 4rem;
          }
          @media screen and (max-width: 967px) {
            font-size: 3rem;
            margin-top: 0.4rem;
          }
          @media screen and (max-width: 760px) {
            font-size: 2.5rem;
            margin-top: 0.6rem;
          }
        }
      }
    }
    a {
      text-decoration: none;
      button {
        width: 18rem;
        font-size: 1.8rem;
        height: 3.5rem;
        letter-spacing: 0.05rem;
        margin-top: 0.5rem;
        color: #966215;
        cursor: pointer;
        border-radius: 0.5rem;
        background: #193549;
        border: 5px solid #1c5661;
        transition: all 0.3s ease-in;
        display: flex;
        justify-content: space-around;
        align-items: center;
        :hover {
          transform: scale(1.05);
          border: 2.5px solid #1c5661;
        }
        @media screen and (max-width: 1115px) {
          width: 16rem;
          font-size: 1.5rem;
          height: 3.2rem;
        }
        @media screen and (max-width: 1115px) {
          width: 14rem;
          font-size: 1.3rem;
          height: 3rem;
        }
        @media screen and (max-width: 760px) {
          width: 10rem;
          font-size: 1rem;
          height: 2.5rem;
        }
      }
    }
  }
`;
